// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2G2fS","inputWrap":"Table_inputWrap__2eTcE","col":"Table_col__FzTP4","bmiTooltip":"Table_bmiTooltip__37piC"};